import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

const CtaButtonModalBody = ({ buttonText, destinationUrl, disclosure }) => {
  const { trackEvent } = useEventTracking();

  return (
    <div className="w-full">
      <PrimaryButton
        as="link"
        className="w-full"
        href={destinationUrl}
        onClickCapture={() =>
          trackEvent(
            click({
              clickLink: destinationUrl,
              clickTarget: ClickTarget.AnchorLink,
              clickText: buttonText,
            })
          )
        }
      >
        {buttonText}
      </PrimaryButton>
      <div className="mt-8 text-center font-suisse-screen text-body-sm text-grayscale-beige">
        {disclosure}
      </div>
    </div>
  );
};

export default CtaButtonModalBody;
